<template>
  <div class="container_self">
    <h3>{{ movieName }}</h3>
    <el-row class="table_parent">
      <el-table :data="episodeList" v-loading="loading">
        <el-table-column label="名称" align="center" prop="episodeName"></el-table-column>
        <el-table-column label="剧集封面" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.image"
              placement="top"
            >
              <span class="table_span">{{ scope.row.image }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="视频链接" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.url"
              placement="top"
            >
              <span class="table_span">{{ scope.row.url }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="集数" align="center" prop="episode"></el-table-column>
        <el-table-column label="视频类型" align="center" prop="fileExt"></el-table-column>
        <el-table-column label="是否付费" align="center" prop="needPay"></el-table-column>
        <el-table-column label="价格" align="center" prop="payPrice"></el-table-column>
        <el-table-column label="点播次数" align="center" prop="playCount"></el-table-column>
        <el-table-column label="广告" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.needAd ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          align="center"
          prop="createTime"
          width="180"
        ></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="180">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="updateVideo(scope.row)">更新</el-button>
            <el-button size="mini" type="danger" @click="deleteVideo(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="episodeSearch.currentPage"
        :page-sizes="[10, 20, 50, 100, 200, 200, 1000]"
        :page-size="episodeSearch.pageSize"
        layout="total, sizes,prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-row>

    <el-dialog
      :title="string + '剧集'"
      :visible.sync="dialogFormVisible3"
      style="z-index:3000"
      class="zIndex"
      top="0"
      :close-on-click-modal="false"
      label-width="120px"
    >
      <el-form
        :model="addEpisodeForm"
        class="search_parent"
        size="mini"
        top="0"
        :rules="addEpisodeRules"
        label-width="120px"
      >
        <el-form-item label="集数" prop="episode">
          <el-input
            v-model="addEpisodeForm.episode"
            placeholder="请输入当前视频在短剧中的集数"
          ></el-input>
        </el-form-item>
        <el-form-item label="分集名称" prop="episodeName">
          <el-input
            v-model="addEpisodeForm.episodeName"
            autocomplete="off"
            placeholder="请输入当前视频名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传视频">
          <el-upload
            drag
            action="https://adminapi.ci-ads.com/api/movie/upload/file"
            style="display: inline-block; margin-left: 15px"
            class="upload-demo"
            :with-credentials="true"
            multiple
            :limit="1"
            accept=".mp4"
            :auto-upload="true"
            :headers="{ Authorization: token  }"
            :show-file-list="true"
            ref="uploadVideo"
            :on-success="handleAvatarSuccess"
            :file-list="fileList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传mp4文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频链接">
          <el-input v-model="addEpisodeForm.url" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="视频大小">
          <el-input v-model="addEpisodeForm.size" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="视频类型">
          <el-input v-model="addEpisodeForm.fileExt" disabled placeholder=""></el-input>
        </el-form-item>

        <el-form-item label="上传封面">
            <el-upload
              drag
              action="https://adminapi.ci-ads.com/api/movie/upload/file"
              style="display: inline-block; margin-left: 15px"
              class="upload-demo"
              :with-credentials="true"
              multiple
              :limit="1"
              ref="uploadImage"
              accept=".jpg,.png"
              :auto-upload="true"
              :headers="{ Authorization:token }"
              :show-file-list="true"
              :on-success="handleAvatarSuccessImg"
              :file-list="fileList1"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </el-form-item>
          <el-form-item label="图片">
            <el-input
              disabled
              v-model="addEpisodeForm.image"
              clearable
            ></el-input>
          </el-form-item>
        <el-form-item label="是否需要广告">
          <el-select v-model="addEpisodeForm.needAd">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否需要付费">
          <el-select v-model="addEpisodeForm.needPay">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付价格">
          <el-input
            v-model="addEpisodeForm.payPrice"
            placeholder="请选输入支付价格"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="submitAddEpisodeForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
export default {
  props: {
    id: String,
    movieName: String,
  },
  data() {
    return {
      episodeList: [],
      loading: false,
      episodeSearch: {
        episodeName: "",
        currentPage: 1,
        pageSize: 10,
        needAd: "",
        needPay: "",
        movieId: this.id,
      },
      total: 0,
      dialogFormVisible3: false,
      string: "添加",
      addEpisodeForm: {
        episode: "",
        episodeName: "",
        fileExt: "",
        image: "",
        movieId: "",
        needAd: "",
        needPay: "",
        payPrice: "",
        size: "",
        summary: "",
        url: "",
      },
      fileList: [],
      addEpisodeForm: {
        episode: "",
        episodeName: "",
        fileExt: "",
        image: "",
        movieId: "",
        needAd: "",
        needPay: "",
        payPrice: "",
        size: "",
        summary: "videosummary",
        url: "",
      },
      edit:false,
      fileList1:[],
      addEpisodeRules:{
        episode:[
            {required:true,message:"请输入剧集集数",trigger: "blur"},
            {
            pattern: /^(\d+|\d*\\d{1,10})$/,
            message: "集数只能是整数",
            trigger: "blur",
          }
        ],
        episodeName:[
            {required:true,message:"请输入剧集名称",trigger: "blur"},
          ]
      },
      token:JSON.parse(sessionStorage.getItem('loginData')).token
    };
  },
  methods: {
    deleteVideo(row){
        console.log(row);
        this.$confirm('此操作将永久删除'+ row.episodeName+ ' 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axiosPost('/api/movie/episode/delete',{id:row.id},"JSON").then(res=>{
            if(res.code==0){
                this.getList(this.episodeSearch);
            }
          })
        }).catch(() => {});
    },
    handleAvatarSuccessImg(res){
        if (res.code == 0) {
            this.addEpisodeForm.image = res.data.url;
            this.$refs.uploadImage.clearFiles();
            this.$forceUpdate();
            // this.$refs.uploadLargeCover.clearFiles();
        }
    },
    updateVideo(row){
        this.edit=true;
        this.addEpisodeForm.episode=row.episode;
        this.addEpisodeForm.episodeName=row.episodeName;
        this.addEpisodeForm.movieId=row.movieId;
        this.addEpisodeForm.id=row.id;
        this.addEpisodeForm.url=row.url;
        this.addEpisodeForm.size=row.size;
        this.addEpisodeForm.fileExt=row.fileExt;
        this.addEpisodeForm.image=row.image;
        this.addEpisodeForm.needAd=row.needAd;
        this.addEpisodeForm.needPay=row.needPay;
        this.addEpisodeForm.payPrice=row.payPrice;
        this.dialogFormVisible3=true;
    },
    submitAddEpisodeForm() {
        console.log("aaa");
        axiosPost("/api/movie/episode/update", this.addEpisodeForm, "JSON").then((res) => {
            if (res.code == 0) {
                this.$message({ message: "更新剧集成功", type: "success" });
                this.dialogFormVisible3 = false;
                this.getList(this.episodeSearch);
            }
        });
    },
    async getList(params) {
      this.loading = true;
      await axiosGet("/api/movie/episode/list", params).then((res) => {
        if (res.code == 0) {
          this.total = res.data.total;
          this.episodeList = res.data.records;
        }
      });
      this.loading = false;
    },
    handleSizeChange(val) {
      this.episodeSearch.pageSize = val;
      this.getList(this.episodeSearch);
    },
    handleCurrentChange(val) {
      this.episodeSearch.currentPage = val;
      this.getList(this.episodeSearch);
    },
    addEpisode() {
      this.dialogFormVisible3 = true;
    },
    handleAvatarSuccess(res) {
      if (res.code == 0) {
        this.addEpisodeForm.url = res.data.url;
        this.addEpisodeForm.size = res.data.size;
        this.addEpisodeForm.fileExt = res.data.ext;
        this.$refs.uploadVideo.clearFiles();
      }
    },
  },
  mounted() {
    console.log("ID",this.episodeSearch.movieId);
    this.getList(this.episodeSearch);
  },
  watch: {
    id: function (a, b) {
        console.log(a);
      this.episodeList = [];
      this.id = a;
      this.episodeSearch.movieId = a;
      this.episodeSearch.pageSize = 10;
      this.getList(this.episodeSearch);
    },
    movieName: function (a, b) {
      this.movieName = a;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/videoManager/episodeManager.vue